document.addEventListener("DOMContentLoaded", () => {
  const emblaNode = document.querySelector(".embla");

  if (!emblaNode) return;

  const viewport = emblaNode.querySelector(".embla__viewport");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const autoplay = EmblaCarouselAutoplay({
    delay: 4000,
    stopOnInteraction: true,
    playOnInit: !reduceMotion,
  });

  const embla = EmblaCarousel(viewport, { loop: true }, [autoplay]);

  const dotsContainer = emblaNode.querySelector(".embla__dots");
  const dots = [];

  // Create dots
  embla.slideNodes().forEach((_, index) => {
    const dot = document.createElement("button");
    dot.type = "button";
    dot.classList.add("embla__dot");
    dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
    dot.addEventListener("click", () => embla.scrollTo(index));

    dotsContainer.appendChild(dot);
    dots.push(dot);
  });

  // Update active dot
  function updateDots() {
    const selectedIndex = embla.selectedScrollSnap();

    dots.forEach((dot, index) => {
      const isSelected = index === selectedIndex;

      dot.classList.toggle("is-selected", isSelected);

      if (isSelected) {
        dot.setAttribute("aria-current", "true");
      } else {
        dot.removeAttribute("aria-current");
      }
    });
  }

  embla.on("select", updateDots);
  embla.on("init", updateDots);

  const PAUSE_ICON =
    '<svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true" focusable="false"><rect x="3" y="2" width="3.5" height="12" fill="currentColor"/><rect x="9.5" y="2" width="3.5" height="12" fill="currentColor"/></svg>';
  const PLAY_ICON =
    '<svg viewBox="0 0 16 16" width="10" height="10" aria-hidden="true" focusable="false"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg>';

  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.className = "embla__playpause";
  dotsContainer.insertBefore(toggle, dotsContainer.firstChild);

  function isPlaying() {
    return autoplay.isPlaying ? autoplay.isPlaying() : false;
  }

  function syncToggle() {
    const playing = isPlaying();
    toggle.innerHTML = playing ? PAUSE_ICON : PLAY_ICON;
    toggle.setAttribute("aria-label", playing ? "Pause slideshow" : "Play slideshow");
  }

  toggle.addEventListener("click", () => {
    if (isPlaying()) {
      autoplay.stop();
    } else {
      autoplay.play();
    }
    syncToggle();
  });

  emblaNode.addEventListener("focusin", () => {
    if (isPlaying()) {
      autoplay.stop();
      syncToggle();
    }
  });

  embla.on("autoplay:play", syncToggle);
  embla.on("autoplay:stop", syncToggle);
  syncToggle();
});
